import { useCallback, useState } from 'react';
import emailDraftsService from 'services/emailDraftsService';

/**
 * Generates an AI-drafted LP outreach email and owns the request state, so
 * consumers only deal with presentation.
 *
 * @returns {Object} { generate, reset, draft, loading, error }
 */
const useGenerateDraft = () => {
	const [draft, setDraft] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const generate = useCallback(
		async ({ tenantId, topic, salesforceObjectType, salesforceObjectId }) => {
			setLoading(true);
			setError(null);

			try {
				const result = await emailDraftsService.generateDraft(tenantId, {
					topic,
					salesforceObjectType,
					salesforceObjectId,
				});

				setDraft(result);

				return result;
			} catch (err) {
				// emailDraftsService already produces user-safe messages. Rethrow so the
				// caller can surface it however it presents errors.
				setError(err.message);

				throw err;
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	// Clears a draft that no longer matches the user's selection.
	const reset = useCallback(() => {
		setDraft(null);
		setError(null);
	}, []);

	return { generate, reset, draft, loading, error };
};

export default useGenerateDraft;
